import { usePanorama } from '@wix/yoshi-flow-editor';
import { settleApiCall } from 'root/api/utils/settleApiCall';
import type { Transaction } from 'root/utils/monitoring/types';

type MonitoringTools = {
  panorama: ReturnType<typeof usePanorama>;
  shouldReportErrorPanorama?: boolean;
};

export const useMonitoredApiCall = () => {
  const panorama = usePanorama();

  return getMonitoredApiCall({ panorama, shouldReportErrorPanorama: true });
};

export const getMonitoredApiCall = ({ panorama, shouldReportErrorPanorama }: MonitoringTools) => {
  return async <T>(callback: () => Promise<T>, transaction: Transaction) => {
    panorama.transaction(transaction.toString()).start();
    const { data, error } = await settleApiCall<T>(callback);
    panorama.transaction(transaction.toString()).finish();
    if (shouldReportErrorPanorama && error) {
      const panoramaError = new Error(`[${transaction.toString()}] - ${error.message}`);
      panorama.errorMonitor().reportError(panoramaError, {
        context: {
          error,
        },
        tags: {
          layer: 'api',
          name: transaction.toString(),
          requestId: error.requestId,
        },
      });
    }
    return { data, error };
  };
};
